// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".box[data-v-fb4c2316]{background:#fff;margin-bottom:10px}.clients[data-v-fb4c2316]{padding:15px 0;text-align:center}.clients img[data-v-fb4c2316]{max-width:45%;transition:all .4s ease-in-out;display:inline-block;padding:15px 0}.clients img[data-v-fb4c2316]:hover{transform:scale(1.15)}@media (max-width:768px){.clients img[data-v-fb4c2316]{max-width:40%}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
